import { Controller } from "@hotwired/stimulus"

// Service Checklist Controller
// Manages the collapsible service checklist panel in the chat view
// Shows detected service items and allows toggling visibility
export default class extends Controller {
  static targets = ["panel", "items"]

  connect() {
    // Check if panel should be shown by default (e.g., if there are new items)
    this.isExpanded = false
  }

  toggle() {
    if (this.hasPanelTarget) {
      this.isExpanded = !this.isExpanded

      if (this.isExpanded) {
        this.panelTarget.classList.remove("hidden")
        // Animate in
        this.panelTarget.style.maxHeight = "0px"
        this.panelTarget.style.overflow = "hidden"
        this.panelTarget.offsetHeight // Force reflow
        this.panelTarget.style.transition = "max-height 0.3s ease-out"
        this.panelTarget.style.maxHeight = this.panelTarget.scrollHeight + "px"

        // After animation, remove inline styles
        setTimeout(() => {
          this.panelTarget.style.maxHeight = ""
          this.panelTarget.style.overflow = ""
          this.panelTarget.style.transition = ""
        }, 300)
      } else {
        // Animate out
        this.panelTarget.style.maxHeight = this.panelTarget.scrollHeight + "px"
        this.panelTarget.offsetHeight // Force reflow
        this.panelTarget.style.transition = "max-height 0.3s ease-out"
        this.panelTarget.style.maxHeight = "0px"
        this.panelTarget.style.overflow = "hidden"

        setTimeout(() => {
          this.panelTarget.classList.add("hidden")
          this.panelTarget.style.maxHeight = ""
          this.panelTarget.style.overflow = ""
          this.panelTarget.style.transition = ""
        }, 300)
      }
    }
  }

  // Called when new items are added via turbo stream or AJAX
  itemsChanged() {
    // Flash animation to indicate new items
    if (this.hasItemsTarget) {
      const newItem = this.itemsTarget.lastElementChild
      if (newItem) {
        newItem.classList.add("animate-pulse", "ring-2", "ring-purple-500")
        setTimeout(() => {
          newItem.classList.remove("animate-pulse", "ring-2", "ring-purple-500")
        }, 2000)
      }
    }

    // Auto-expand panel if it was hidden
    if (!this.isExpanded && this.hasPanelTarget) {
      this.toggle()
    }
  }

  // Update badge count dynamically
  updateCount(count) {
    const badge = this.element.querySelector('[data-service-checklist-badge]')
    if (badge) {
      badge.textContent = count
    }
  }
}
